import Layout from '@/layouts/Layout';
import { Link, useForm } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import type { ChatSummary } from '@domain/chat';
import { normalizeChatMessages, normalizeChatSummary } from '@domain/chat';
import { formatDayLabel } from '@/lib/date';
import { ChevronRight } from 'lucide-react';

const formatOpenedDisplay = (value?: string | null) => {
  if (!value) return null;
  const label = formatDayLabel(value);
  if (!label) return null;
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export default function Index({ chats }: { chats: ChatSummary[] }) {
  const { post, processing } = useForm({});

  const handleNewChat = (e: React.FormEvent) => {
    e.preventDefault();
    post('/patients/chats', { preserveScroll: true });
  };

  return (
    <Layout user={{ name: 'Cliente' }}>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Le tue chat</h1>
        <form onSubmit={handleNewChat}>
          <Button type="submit" disabled={processing}>
            Nuova chat
          </Button>
        </form>
      </div>
      <Card className="p-0">
        <ul className="divide-y divide-border">
          {chats.map((rawChat) => {
            const chat = normalizeChatSummary(rawChat);
            const messages = normalizeChatMessages(chat.messages);
            const last = messages[messages.length - 1];
            const openedDisplay = formatOpenedDisplay(chat.createdAt);
            return (
              <li key={chat.id}>
                <Link
                  href={`/patients/chats/${chat.id}`}
                  className="flex items-center justify-between gap-4 px-4 py-3 transition-transform duration-150 ease-out hover:scale-[1.01] hover:bg-muted/40 hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60"
                >
                  <div className="flex-1">
                    <span className="font-semibold">{chat.title ?? `Chat #${chat.id}`}</span>
                    {openedDisplay && (
                      <span className="ml-2 text-sm font-normal text-muted-foreground">
                        {openedDisplay}
                      </span>
                    )}
                    {last && (
                      <p className="text-sm text-muted-foreground mt-1 line-clamp-1">
                        {last.role === 'user' ? 'Tu: ' : 'Assistente: '}
                        {last.content}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center gap-1 text-sm text-muted-foreground">
                    <span>Apri</span>
                    <ChevronRight className="h-4 w-4" />
                  </div>
                </Link>
              </li>
            );
          })}
          {chats.length === 0 && (
            <li className="p-6 text-center text-muted-foreground">
              Nessuna chat presente. Crea la prima.
            </li>
          )}
        </ul>
      </Card>
    </Layout>
  );
}
